import { useEffect, useState } from "react";
import useDataBean from "../../core/services/dataBean/useDataBean";
import { _Entailment, _single } from "../../core/services/dataBean/EntityCatalog";
import { Singleton } from "../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../theme/Component/ListMenu";
import { BasicPage } from "../theme/Component/BasicPage";
import { BasicTable } from "../theme/Component/BasicTable";
import { Modal } from "../theme/Component/Modal";
import { ModalConfirm } from "../theme/Component/ModalConfirm";
import { _AdquisitionPlanByYear } from "../../core/services/dataBean/EntityCatalogVdos";
import { YearSelector } from "../../core/shared/inputs/YearSelector";



export const DashBoardPlanNew = () => {

    const adquisitionplan = useDataBean(_AdquisitionPlanByYear);
    const single = Singleton.getInstance();

    const [lista, setLista] = useState<any>([]);
    const [appoGroup, setAppoGroup] = useState<number>(null)
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const [response, setResponse] = useState<any>({

        Year: _single.getCurrenYear(),
    });
    useEffect(() => {

    }, [])

    const getLista = () => {

        adquisitionplan.instance.getAdquisitionPlanByYear(response.Year).then(
            (resp: any) => {
                if (resp) {

                    setLista(resp);
                    console.log(resp)
                }
            }
        )

    }

    const create = () => {
        adquisitionplan.setBean({

        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        adquisitionplan.deleteItemVoid(adquisitionplan.bean.IDEntailment).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "name": `x`, "view": false });
            }
        )

    }
    const editaItem = () => {
        //console.log(entailment.bean);
        adquisitionplan.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDAdquisitionPlan', visible: true },
        { title: 'Nombre', property: 'Description', visible: true },
        { title: 'Estado  del plan', property: 'PlanningStateName', visible: true },
        { title: 'Fase', property: 'PlanState', visible: true },
        { title: 'Fecha', property: 'Since', visible: true },
    ]

    // const iconButtonsItem = [
    //     { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    // ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "name": `Editar ${adquisitionplan.bean.Name}`, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Consultar Plan por Año">
            <div className="row">
                <div className="col-md-6">
                    <YearSelector value={response.Year} onChange={(e) => { setResponse({ ...response, "Year": e }) }} tittle="Vigencia" />
                </div>
                <div className="col-md-6">
                    <button className="btn btn-primary shadow-none" type="button" id="button-addon2" onClick={getLista}>Buscar</button>
                </div>
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={adquisitionplan.setBean} listButtons={listaBotones()} ></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">

                            <div className="col-md-6">
                                <label>Código</label>
                                <input type="text" name="Code" className="form-control" value={adquisitionplan.bean.Code} onChange={adquisitionplan.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label>Nombre</label>
                                <input type="text" name="Name" className="form-control" value={adquisitionplan.bean.Name} onChange={adquisitionplan.handleChange} />
                                {/* <SelectFunctionalID renderValue="" onChange={()=>{}}/> */}
                            </div>
                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {adquisitionplan.bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}